import React, { useState, useEffect } from "react";
import moment from "moment/moment";
import axiosInstance from "../../axios";


const Ticker = () => {
  const [time, setTime] = useState({
    hours: 0,
    min: 0,
    sec: 0,
    data: false,
  });

  const [webinar, setWebinar] = useState([]);
  const [fetchWebinarRecord, setFetchWebinarRecord] = useState(true);
  const now = new Date();
  const firstDay = moment(
    new Date(now.getFullYear(), now.getMonth(), 1)
  ).format("YYYY MM,DD");
  const lastDay = moment(
    new Date(now.getFullYear(), now.getMonth() + 1, 0)
  ).format("YYYY MM,DD");

  const centralizeData = (response) => {
    return response?.map((el) => ({
      start: moment(el.webinarDate).format("YYYY-MM-DD"),
      title: el.eventName,
      id: el.id,
      eventEndTime: el.endTime,
      eventStartTime: el.startTime,
      endDate: el.endDate,
    }));
  };

  useEffect(() => {
    axiosInstance
      .get(`webinar/all?startDate=${firstDay}&endDate=${lastDay}`)
      .then((response) => {
        setFetchWebinarRecord(false);
        setWebinar(centralizeData(response.data.data));
      })
      .catch((err) => {
        console.log(err);
        setFetchWebinarRecord(false);
      });
  }, []);

  const getTimes = (webinardata) => {
    var datenow = moment(new Date()).format("YYYY-MM-DD");
    var startdatenow = moment(datenow, "YYYY-MM-DD");
    var dateend = moment(webinar[0]?.start, "YYYY-MM-DD");
    var dateduration = moment.duration(dateend.diff(startdatenow));
    var days = dateduration.asHours();
    if (days <= 24) {
      var now = new Date().getTime();
      var dates = JSON.stringify(moment(now).format("HH:mm:ss"));
      var startTime = moment(dates, "HH:mm:ss");
      var endTime = moment(webinardata[0]?.eventStartTime, "HH:mm:ss");
      var duration = moment.duration(endTime.diff(startTime));
      var hours = parseInt(duration.asHours());
      var minutes = parseInt(duration.asMinutes()) % 60;
      var sec = (parseInt(duration.asSeconds()) % 60) % 60;
      return setTime({
        hours: hours,
        min: minutes,
        sec: sec,
        data: true,
      });
    } else {
      return setTime({
        data: false,
      });
    }
  };

  useEffect(() => {
    const setTicker = (webinar) =>
      setInterval(() => {
        getTimes(webinar);
      }, 1000);
    if (webinar.length > 0) {
      setTicker(webinar);
    }

    return () => clearTimeout(setTicker);
  }, [webinar]);

  return (
    time?.data && (
      <div className="dashboard-main">
        <p className="margin-r-15">Today's Webinar:</p>
        <p className="studentDashboard-headerLine">{webinar[0]?.title}</p>
        <button className="lastmonth-btn">
          {time?.hours > 9 ? time.hours : `0${time?.hours}`}:
          {time?.min > 9 ? time.min : `0${time?.min}`}:
          {time?.sec > 9 ? time.sec : `0${time?.sec}`}
        </button>
        <button className="export-btn joinWebinar-btn">Join</button>
      </div>
    )
  );
};

export default Ticker;
